import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import RCResults, { RCResultsProps } from './rc-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/mortgages/refinance-calculator/calculate-refinance-savings`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: {
        pageTaxonomy: getTaxonomy('rc'),
      },
      driverPageName: 'mortgages_refinance_calculator',
    };
  },
};

const RCResultsWrapper = (props: RCResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={RCResults}
    />
  );
};

export default RCResultsWrapper;
